<template>
  <IconSvgBase :class="$style.icon" :view-width="24" :view-height="24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16ZM12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15ZM18 20H6C5.449 20 5 19.551 5 19V13H19V19C19 19.551 18.551 20 18 20ZM6 6H7V7C7 7.55 7.45 8 8 8C8.55 8 9 7.55 9 7V6H15V7C15 7.55 15.45 8 16 8C16.55 8 17 7.55 17 7V6H18C18.551 6 19 6.449 19 7V11H5V7C5 6.449 5.449 6 6 6ZM18 4H17V3C17 2.45 16.55 2 16 2C15.45 2 15 2.45 15 3V4H9V3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3V4H6C4.346 4 3 5.346 3 7V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V7C21 5.346 19.654 4 18 4Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconCalendar',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__path {
    fill: currentcolor;
  }
}
</style>
